<div class="conversation-list-item" [attr.data-testid]="testId + '-wrapper'">
  <button
    type="button"
    class="conversation-history__button"
    [attr.data-testid]="testId + '-select'"
    [class.conversation-history__button--selected]="selected"
    [attr.aria-current]="selected ? 'true' : null"
    (click)="onConversationSelected()"
  >
    <span class="conversation-history__item-title">{{ item.title || item.previewText }}</span>
    <time
      *ngIf="item.lastActivityDate"
      class="conversation-history__item-meta"
      [attr.datetime]="item.lastActivityDate"
      >{{ item.lastActivityDate | timeAgo }}</time
    >
  </button>

  <input
    *ngIf="isEditing"
    #renameInput
    class="conversation-list-item__rename-input"
    [attr.data-testid]="testId + '-rename-input'"
    [value]="draftTitle"
    [attr.aria-label]="'certify.chatbot.history.actions.renameInput' | translate"
    maxlength="21"
    (input)="onTitleInput($event)"
    (keydown)="onRenameKeydown($event)"
    (blur)="saveRename()"
  />

  <button
    *ngIf="!isEditing"
    cdkOverlayOrigin
    #menuOrigin="cdkOverlayOrigin"
    #menuButton
    type="button"
    class="conversation-list-item__action"
    [attr.data-testid]="testId + '-actions-trigger'"
    [attr.aria-label]="'certify.chatbot.history.actions.openMenu' | translate"
    [attr.aria-expanded]="menuOpen"
    aria-haspopup="menu"
    [class.conversation-list-item__action--open]="menuOpen"
    (click)="toggleMenu($event)"
  >
    <cwc-icon
      [attr.data-testid]="testId + '-actions-icon'"
      name="menu-additional-options-ver"
      size="20px"
      color="bright-blue"
    ></cwc-icon>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="menuOrigin"
    [cdkConnectedOverlayOpen]="menuOpen"
    [cdkConnectedOverlayPositions]="menuPositions"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayViewportMargin]="8"
    (backdropClick)="closeMenu()"
    (overlayKeydown)="onMenuKeydown($event)"
  >
    <div
      class="conversation-list-item__menu"
      [attr.data-testid]="testId + '-menu'"
      role="menu"
      [attr.aria-label]="'certify.chatbot.history.actions.menu' | translate"
    >
      <button
        *ngIf="!pinned"
        type="button"
        role="menuitem"
        [attr.data-testid]="testId + '-pin'"
        (click)="onMenuAction('pin')"
      >
        <cwc-icon [attr.data-testid]="testId + '-pin-icon'" name="pin-filled" size="18px"></cwc-icon>
        <span>{{ 'certify.chatbot.history.actions.pin' | translate }}</span>
      </button>
      <button
        *ngIf="pinned"
        type="button"
        role="menuitem"
        [attr.data-testid]="testId + '-remove-pin'"
        (click)="onMenuAction('removePin')"
      >
        <cwc-icon [attr.data-testid]="testId + '-remove-pin-icon'" name="pin-filled" size="15px"></cwc-icon>
        <span>{{ 'certify.chatbot.history.actions.removePin' | translate }}</span>
      </button>
      <button type="button" role="menuitem" [attr.data-testid]="testId + '-rename'" (click)="onMenuAction('rename')">
        <cwc-icon [attr.data-testid]="testId + '-rename-icon'" name="edit" size="15px"></cwc-icon>
        <span>{{ 'certify.chatbot.history.actions.rename' | translate }}</span>
      </button>
      <button type="button" role="menuitem" [attr.data-testid]="testId + '-delete'" (click)="onMenuAction('delete')">
        <cwc-icon [attr.data-testid]="testId + '-delete-icon'" name="trash" size="15px"></cwc-icon>
        <span>{{ 'certify.chatbot.history.actions.delete' | translate }}</span>
      </button>
    </div>
  </ng-template>
</div>
